// utils/app-version.js
function isObjectEmpty(obj) {
  // Check if it's null or undefined
  if (obj === null || obj === undefined) {
    return true;
  }

  // Check if it's an object and has no keys
  if (typeof obj === 'object' && Object.keys(obj).length === 0) {
    return true;
  }

  return false;
}

const versionKeys = {
  plates: ['cache_plates', 'cache_legal_plates'],
  partners: ['cache_partners'],
  groups: ['cache_groups'],
  tracking: ['cache_tracking'],
  status: ['cache_status'],
  // Add more version keys if needed
};

export const checkVersion = (arg) => {
  if (isObjectEmpty(arg)) return;

  Object.entries(versionKeys).forEach(([key, caches]) => {
    const newVersion = arg[key] || 0;
    if (!newVersion) return;

    const versionKey = `${key}_version`;
    const storedVersion = parseInt(localStorage.getItem(versionKey) || '0');

    if (storedVersion < newVersion) {
      localStorage.setItem(versionKey, newVersion);
      caches.forEach((cacheKey) => localStorage.removeItem(cacheKey));
    }
  });
};

/**
 * @deprecated since 2025-04-30 - Use checkVersion instead.
 */
// Check version
export const _checkVersion = (arg) => {
  // Reload cache
  // localStorage.removeItem('cache_overview');
  if(isObjectEmpty(arg)){ return; }

  let version = arg.plates || 0;
  if(version){
    plateVersion(version);
  }

  version = arg.partners || 0;
  if(version){
    partnerVersion(version);
  }

  version = arg.groups || 0;
  if(version){
    groupVersion(version);
  }
  
};

// Car cache
function plateVersion (version) {
  const myVersion = localStorage.getItem('plate_version') || 0;
  if(myVersion < version){
    localStorage.setItem('plate_version', version);

    localStorage.removeItem('cache_plates');
    localStorage.removeItem('cache_legal_plates');
  }
}

// Partner cache
function partnerVersion (version) {
  const myVersion = localStorage.getItem('partner_version') || 0;
    if(myVersion < version){
      localStorage.setItem('partner_version', version);

      localStorage.removeItem('cache_partners');
    }
}

// Group cache
function groupVersion (version) {
  const myVersion = localStorage.getItem('group_version') || 0;
    if(myVersion < version){
      localStorage.setItem('group_version', version);

      localStorage.removeItem('cache_groups');
    }
}